import React from "react";
import { Alert, Col } from "react-bootstrap";
import { Navigate, useLocation, useParams } from "react-router-dom";
import countries from "../information/countries.json";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";

const CountrySpecific = () => {
    const { countryID } = useParams();
    const information = countries[countryID];
    const { state } = useLocation();
    const { addBreadcrumb } = useBreadcrumbs();

    if (information.restrictions) {
        return (
            <AnimateWrapper>
                <div>
                    <Alert variant="danger">
                        <p className="my-0">
                            <span className="fw-bold">
                                Er zijn restricties voor het versturen van pakketten
                                naar {information.full_name}:
                            </span>
                            <br />
                            {information.restrictions}
                            <br />
                            {state.countryFrom === "NL" && (
                                <>
                                    {information.restrictions_NL}
                                    <br />
                                </>
                            )}
                            {state.countryFrom === "BE" && (
                                <>
                                    {information.restrictions_BE}
                                    <br />
                                </>
                            )}
                        </p>
                    </Alert>
                </div>
                <BasicQuestion
                    answers={
                        <>
                            <Col xs={12}>
                                <ChoiceCard
                                    body={"Klik hier om verder te gaan"}
                                    onClick={() => {
                                        if (countryID === "US") {
                                            addBreadcrumb({
                                                href: "/state",
                                                text: "Staat"
                                            });
                                        } else {
                                            addBreadcrumb({
                                                href: "/gift",
                                                text: "Geschenk"
                                            });
                                        }
                                    }}
                                />
                            </Col>
                        </>
                    }
                />
            </AnimateWrapper>
        );
    } else {
        return (
            <Navigate
                to="/gift"
                state={{
                    ...state,
                    breadcrumbs: [
                        ...state.breadcrumbs.filter(
                            (item) => item.href !== `/country/${countryID}`
                        ),
                        {
                            href: `/country/${countryID}`,
                            text: information.full_name,
                            disabled: true
                        },
                        { href: "/gift", text: "Geschenk" }
                    ]
                }}
                replace
            />
        );
    }
};

export default CountrySpecific;
